export default "<template>\r\n  <v-file-input accept=\"image/*\" label=\"File input\"></v-file-input>\r\n</template>\r\n";